
    export default {
        name: 'DrifterZoneSideWidget',
        data() {
            return {
                isShowQRCode: true,
            }
        },
        methods: {
            handleClickShowQRCode() {
                this.isShowQRCode = !this.isShowQRCode;
            }
        }
    }
